











import { Component, Mixins } from 'vue-property-decorator';
import { MixinChartGroupEvolution } from '@/plugins/podolib/services/helper/mixins/chart/evolution';
//
import ChartEvolutionWalkingPhaseContactTime from '@/components/charts/evolution/ChartEvolutionWalkingPhaseContactTime.vue';
import ChartEvolutionWalkingPhaseOscillationTime from '@/components/charts/evolution/ChartEvolutionWalkingPhaseOscillationTime.vue';

@Component({
  components: {
    ChartEvolutionWalkingPhaseContactTime,
    ChartEvolutionWalkingPhaseOscillationTime,
  },
})
export default class ChartsGroupEvolutionWalkingPhase extends Mixins(MixinChartGroupEvolution) {}
